import React from 'react';
import ReactDOM from 'react-dom';
import JourneyCtaSection from '../components/JourneyCtaSection';
import { initializeI18n } from '../localization/i18n';
window.renderJourneyCtaSection = (elementId, props) => {
  const el = document.getElementById(elementId);
  if (el) initializeI18n().then(() => ReactDOM.render(<JourneyCtaSection props={props} />, el)).catch(() => {});
};
